import AVATAR1 from "./../../../assets/male1.jpg";
import AVATAR2 from "./../../../assets/male2.jpg";
import AVATAR3 from "./../../../assets/male3.jpeg";
import AVATAR4 from "./../../../assets/male4.jpg";
import AVATAR5 from "./../../../assets/male5.jpg";
import AVATAR13 from "./../../../assets/female1.jpg";
import AVATAR6 from "./../../../assets/female2.jpg";
import AVATAR7 from "./../../../assets/female3.jpg";
import AVATAR8 from "./../../../assets/female4.jpg";
import AVATAR9 from "./../../../assets/female5.jpg";
import AVATAR10 from "./../../../assets/female6.jpg";
import AVATAR11 from "./../../../assets/female7.jpg";
import AVATAR12 from "./../../../assets/female8.jpg";
import AVATAR14 from "./../../../assets/female9.jpg";
import AVATAR15 from "./../../../assets/female10.jpg";
import AVATAR16 from "./../../../assets/female11.jpg";

const testimonials = [
  {
    name: "Maria Santos",
    review: "Ang staff sobrang approachable at magaan kausap.",
    image: "",
    rating: 4,
  },
  {
    name: "Mark Reyes",
    review: "Super smooth ng treatment, walang hapdi!",
    image: AVATAR1,
    rating: 5,
  },
  {
    name: "Ramon Garcia",
    review: "Highly recommended, sobrang effective ng treatment!",
    image: AVATAR5,
    rating: 4,
  },
  {
    name: "Joshua Dela Cruz",
    review: "Very accommodating sila at magaling mag-explain.",
    image: AVATAR2,
    rating: 5,
  },
  {
    name: "Alyssa Dela Cruz",
    review: "Kitang kita agad ang effect after ng session.",
    image: AVATAR7,
    rating: 3,
  },

  {
    name: "Lianne Navarro",
    review: "Highly recommended lalo na sa first timers!",
    image: AVATAR9,
    rating: 4,
  },
  {
    name: "Bea Villanueva",
    review: "Ang ganda ng service, very professional.",
    image: AVATAR10,
    rating: 5,
  },
  {
    name: "Katrina Lopez",
    review: "Sobrang gaan ng kamay ng staff. Love it!",
    image: AVATAR11,
    rating: 4,
  },
  {
    name: "Luis Villanueva",
    review: "Laging on time ang appointment, very organized.",
    image: AVATAR3,
    rating: 5,
  },
  {
    name: "Jasmine Uy",
    review: "Nag-improve talaga skin ko. Thank you!",
    image: AVATAR12,
    rating: 3,
  },

  {
    name: "Miguel Santos",
    review: "Napaka-propesyonal ng staff at mabilis ang serbisyo.",
    image: "/images/client25.jpg",
    rating: 4,
  },
  {
    name: "Bianca Soriano",
    review: "Hindi lang sila magaling, mababait pa!",
    image: "/images/client14.jpg",
    rating: 5,
  },
  {
    name: "Trisha Bautista",
    review: "Sobrang sulit every peso, sobrang galing!",
    image: AVATAR8,
    rating: 5,
  },
  {
    name: "Andrei Lopez",
    review: "Comfortable at relaxing ang treatment area nila.",
    image: AVATAR14,
    rating: 4,
  },
  {
    name: "Daphne Morales",
    review: "Consistent ang results — very satisfied!",
    image: "/images/client16.jpg",
    rating: 3,
  },
  {
    name: "Carlos Torres",
    review: "Gentle and effective. Worth every visit.",
    image: AVATAR4,
    rating: 4,
  },
  {
    name: "April Carreon",
    review: "Super relaxing ng treatment area nila.",
    image: "/images/client17.jpg",
    rating: 4,
  },

  {
    name: "Carla Mendoza",
    review: "Sobrang linis ng clinic at very relaxing ambiance.",
    image: AVATAR6,
    rating: 5,
  },
  {
    name: "Monique Garcia",
    review: "Friendly staff and very hygienic environment.",
    image: "/images/client19.jpg",
    rating: 4,
  },
  {
    name: "Patricia Chua",
    review: "Thank you for making my skin glow again!",
    image: AVATAR15,
    rating: 4,
  },
  {
    name: "Nina Francisco",
    review: "Sobrang satisfied ako sa result — legit!",
    image: "/images/client21.jpg",
    rating: 5,
  },
  {
    name: "Daniel Cruz",
    review: "Hindi ako nagsisisi sa pagpili ng clinic na ito.",
    image: AVATAR13,
    rating: 3,
  },
  {
    name: "Faye Sarmiento",
    review: "Pangalawang session ko pa lang, kita na agad effect.",
    image: "/images/client23.jpg",
    rating: 4,
  },
  {
    name: "Denise Yulo",
    review: "The best clinic experience ever. Highly recommend!",
    image: AVATAR16,
    rating: 5,
  },
];

export default testimonials;
